import {
  gql 
} from "@apollo/client";
import {
  ProductListingFragment 
} from "../CartPage/ProductListing/productListingFragments.gql.js";

export const MiniCartFragment = gql`
    fragment MiniCartFragment on Cart {
        id
        total_quantity
        prices {
            subtotal_excluding_tax {
                currency
                value
            }
            subtotal_including_tax {
                currency
                value
            }
            grand_total {
                currency
                value
            }
        }
        ...ProductListingFragment
    }
    ${ProductListingFragment}
`;
